"use client";
import Image from "next/image";

import { useState } from "react";
import { useRouter } from "next/navigation";

const About = ({ data }: any) => {
  const router = useRouter();
  // let windowWidth: any;
  // if (typeof window !== "undefined") {
  //   windowWidth = window?.innerWidth;
  //   // Your client-side code that uses window goes here
  // }
  const [isLargeScreen, setIsLargeScreen] = useState();
  // typeof window !== "undefined" ? window?.innerWidth > 768 : false

  // const handleResize = () => {
  //   setIsLargeScreen(
  //     typeof window !== "undefined" ? window?.innerWidth > 768 : false
  //   );
  // };

  // useEffect(() => {
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const app_name: string = process.env.NEXT_PUBLIC_APP_NAME || "";

  return (
    <>
      <style>
        {`
                 @media (max-width: 768px) {
           .about {
             flex-direction: column !important;
           }
         }

        `}
      </style>
      <div
        className="m-10 about"
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "17px",
          margin: "1%",
          gap: "10px",
          borderRadius: "1rem",
          backgroundColor: "#F5F5FF",
          border: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          className="px-6.25"
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1 1 ",
            flexShrink: "0",
            // minWidth: "500px",
          }}
        >
          <h6
            style={{ color: "#666666", fontSize: "1.5rem", fontWeight: "500" }}
          >
            ABOUT
          </h6>
          <h1 style={{ color: "#212121", fontSize: "48px", fontWeight: "400" }}>
            {data[0]?.attributes?.Title}
          </h1>
          <h5
            style={{
              color: "#666666",
              fontSize: "1.3rem",
              fontWeight: "400",
              marginBottom: "20px",
              textAlign: "left",
              fontFamily: "Graphik",
            }}
          >
            {data[0]?.attributes?.Content}
          </h5>
          <button
            className="primary-button"
            type="submit"
            style={{
              display: "flex",
              border: "none",
              fontSize: "14px",
              maxHeight: "40px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "40px",
              padding: "10px 20px",
              cursor: "pointer",
              width: "fit-content",
            }}
            onClick={() => {
              router.push("/about-us");
            }}
          >
            Read More
          </button>
        </div>

        <div
          className="about-image px-6"
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1 1",
            flexShrink: "0",
            minWidth: "300px",
          }}
        >
          <Image
            src={data[0]?.attributes?.Image_Path}
            alt="About us..."
            width={828}
            height={552}
            style={{
              borderRadius: "1.25rem",
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
      </div>
    </>
  );
};

export default About;
